import '../styles/app.scss';
import '../../node_modules/wallop/css/wallop.css';
import '../../node_modules/wallop/css/wallop--fade.css';

window.easings = {};
window.easings.easeStandard = 'cubicBezier(0.25, 0.1, 0.25, 1)';
window.easings.ease = 'cubicBezier(0.25, 0.46, 0.45, 0.94)';
window.easings.andrew = 'cubicBezier(0.77, 0, 0.175, 1)';
window.easings.feebles1 = 'cubicBezier(.8,.03,.25,1)';
window.easings.feebles2 = 'cubicBezier(.72,.01,.25,1)';
window.easings.ease2 = 'cubicBezier(.48,.1,.48,.9)';

// Getting our breakpoint for javascript
window.Breakpoint = {};

Breakpoint.refreshValue = function() {
  this.value = window
    .getComputedStyle(document.querySelector('body'), ':before')
    .getPropertyValue('content')
    .replace(/\"/g, '');
};

$(window)
  .resize(function() {
    Breakpoint.refreshValue();
  })
  .resize();

// Libs
var PubSub = require('underpub-js');
var Sitewide = require('./classes/Sitewide');
var ComponentsLoader = require('./classes/ComponentsLoader');
var SharerJs = require('sharer.js');

$(document).ready(function() {
  var components = [
    {
      handle: '.comp-DesignShowcaseListing',
      require: require('../components/molecules/listings/designShowcaseListing/designShowcaseListing'),
    },
    {
      handle: '.comp-Header',
      require: require('../components/molecules/header/header/header'),
    },
    {
      handle: '.comp-Loader',
      require: require('../components/molecules/loader/loader'),
    },
    {
      handle: '[data-hero-homepage]',
      require: require('../components/molecules/hero/heroHomepage/heroHomepage'),
    },
    {
      handle: '[data-hero-portfolio]',
      require: require('../components/molecules/hero/heroPortfolio/heroPortfolio'),
    },
    {
      handle: '[data-services-markets-carousel]',
      require: require('../components/molecules/misc/servicesMarketsCarousel/servicesMarketsCarousel'),
    },
    {
      handle: '[data-content-with-timeline]',
      require: require('../components/molecules/content/contentWithTimeline/contentWithTimeline'),
    },
    {
      handle: '[data-video-full-with-card]',
      require: require('../components/molecules/video/videoFullWithCard/videoFullWithCard'),
    },
    {
      handle: '[data-location-content]',
      require: require('../components/molecules/misc/locationContent/locationContent'),
    },
    {
      handle: '[data-icon-item-slider]',
      require: require('../components/molecules/slider/iconItemSlider/iconItemSlider'),
    },
    {
      handle: '[data-modal-video]',
      require: require('../components/molecules/modal/modalVideo/modalVideo'),
    },
    {
      handle: '[data-three-up-videos]',
      require: require('../components/molecules/video/threeUpVideos/threeUpVideos'),
    },
    {
      handle: '[data-expandable-slideshow]',
      require: require('../components/elements/expandableSlideshow/expandableSlideshow'),
    },
    {
      handle: '[data-modal-image-gallery]',
      require: require('../components/molecules/modal/modalImageGallery/modalImageGallery'),
    },
    {
      handle: '[data-search]',
      require: require('../components/molecules/misc/search/search'),
    },
    {
      handle: '[data-full-width-image-slider]',
      require: require('../components/molecules/images/fullWidthImageSlider/fullWidthImageSlider'),
    },
	{
		handle: '[data-portfolio]',
		require: require('../components/molecules/misc/portfolio/portfolio'),
	},
	{
		handle: '[data-hero-bg-images]',
		require: require('../components/molecules/hero/heroBgImages/heroBgImages'),
	},
	{
		handle: '[data-hero-bg-images-with-links]',
		require: require('../components/molecules/hero/heroBgImagesWithLinks/heroBgImagesWithLinks'),
	},
	{
		handle: '[data-listing-showcase]',
		require: require('../components/molecules/listings/listingShowcase/listingShowcase'),
	},
	{
		handle: '[data-more-listings]',
		require: require('../components/molecules/listings/moreListings/moreListings'),
	},
  ];

  var sitewide = new Sitewide();
  sitewide.init();

  // Getting our components loading going
  var componentsLoader = new ComponentsLoader({ components: components });
  componentsLoader.initScreen();

  // setting our breakpoint value
  Breakpoint.refreshValue();
});
